<section class="fleetNewItemSection">
  <div class="fleetNewItemSectionDescription">
    <header class="fleetNewItemSectionDescription__title">
      {{ 'new_asset_labels_header' | ppTranslate }}
    </header>
    <div class="fleetNewItemSectionDescription__subtitle">
      {{ 'new_asset_labels_subheader' | ppTranslate }}
    </div>
  </div>

  <div class="fleetNewItemSectionContent" data-test="assetLabelSection">
    <div class="newAssetDetails">
      <section class="newAssetLabels__header">
        <p class="newAssetLabels__header--name">{{ 'name' | ppTranslate }}</p>
        <p class="newAssetLabels__header--color">{{ 'color' | ppTranslate }}</p>
        <p class="newAssetLabels__header--assignee">{{ 'assignee' | ppTranslate }}</p>
      </section>

      <section class="newAssetLabels">
        @for (label of assetLabels; track label) {
          <pp-new-asset-label
            [(ppColor)]="label.color"
            [(ppName)]="label.name"
            [(ppAssigneeId)]="label.assigneeId"
            (ppDeleteLabel)="deleteLabel(label)"
            (ppLabelChange)="updateAssetLabels()"
          ></pp-new-asset-label>
        }
      </section>

      @if (assetLabels.length < 20) {
        <button
          data-test="addLabelButton"
          (click)="addNewLabel()"
          class="newAssetLabelButton"
          >
          {{ 'new_asset_new_label_button' | ppTranslate }}
        </button>
      }
    </div>
  </div>
</section>
